import ng from 'angular';
import {
    AuthContextService,
    AccountHelperService,
    AsteriskNoteType
} from '@/services';
import {
    UiRights,
    CycleBillingTranslationConst,
    ContractPeriodeToBillingCycleConst
} from '@/configuration';
import { ConvertAmountFilter } from '@/filters';
import { RenewPriceInfo } from '@/atomic-components/organisms/forms/edit-forms/ssl/ssl-certificate-edit-callcenter';

// Equivalent to product-price.ts Should only do logic how to show stuff
export class MoleculeFormProductPriceTemplateController implements ng.IController {
    public static $inject: string[] = [
        '$translate',
        'convertAmountFilter',
        'accountHelper'
    ]

    public annualBillingAsteriskNoteType = AsteriskNoteType.ANNUALLY_CONTRACT_PERIOD;
    public pricePrefixText = '';
    public vatAsteriskNoteType: AsteriskNoteType;

    private account = AuthContextService.account;

    // prob. we want a generalized PriceInfo object
    constructor(
        private $translate: ng.translate.ITranslateService,
        private convertAmountFilter: ConvertAmountFilter,
        private accountHelper: AccountHelperService,
        private priceInfo: RenewPriceInfo,
    ) {}

    public $onInit(): void {
        if (this.showVatAsteriskNote) {
            this.vatAsteriskNoteType = this.account.isCommercialCustomer
                ? AsteriskNoteType.VAT_EXCLUDED
                : AsteriskNoteType.VAT_INCLUDED;
        }
    }

    public get state(): string {
        return this.priceInfo.state;
    }

    public get freeOfChargeProduct(): boolean {
        if (this.priceInfo.state === 'loaded') {
            return this.priceInfo.amountScaled10000 === 0;
        }
        return false;
    }

    public get priceIsLoading(): boolean {
        return this.state === 'loading';
    }

    public get priceIsLoaded(): boolean {
        return this.priceInfo.state === 'loaded';
    }

    public get maySeePrices(): boolean {
        return this.state !== 'unknown';
    }

    public get showPrefixText(): boolean {
        return [undefined, null, ''].indexOf(this.pricePrefixText) < 0 && this.maySeePrices;
    }

    public get pricePostfixText(): string {
        if (this.priceInfo.state === 'loaded') {
            return `/ ${this.$translate.instant(CycleBillingTranslationConst[this.priceInfo.billingPeriod])}`;
        }
        return '';
    }

    public get showPostfixText(): boolean {
        return [undefined, null, ''].indexOf(this.pricePostfixText) < 0 && this.maySeePrices;
    }

    public get showAnnualBillingAsteriskNote(): boolean {
        if (this.priceInfo.state === 'loaded') {
            return this.priceInfo.billingPeriod === ContractPeriodeToBillingCycleConst[12];
        }
        return false;
    }

    public get showAnnualBillingAsterisk(): boolean {
        return this.showAnnualBillingAsteriskNote;
    }

    public get priceText(): string {
        if (AuthContextService.isRoot) {
            return this.$translate.instant('d32cbe5d-f0c9-4c61-bfbd-b96446e0a774');
        } else if (
            this.state === 'unknown' ||
                !AuthContextService.isGranted(UiRights.BIL_LIST_ARTICLE_PRICES)
        ) {
            return this.$translate.instant('TR_301019-2f4ae4_TR');
        } else {
            return this._convertPriceToText();
        }
    }

    public get showVatAsterisk(): boolean {
        return this.showVatAsteriskNote;
    }

    public get showVatAsteriskNote(): boolean {
        if (this.state === 'unknown') {
            return false;
        }
        return !this.freeOfChargeProduct
            && !AuthContextService.isRootOrCompanyAccount;
    }

    private _convertPriceToText = (): string => {
        if (this.priceInfo.state === 'loaded') {
            if (this.priceInfo.amountScaled10000 === 0) {
                return this.$translate.instant('ff319345-537f-4dd9-8ae4-134435f7c4d8');
            } else {
                const price = this.priceInfo.amountScaled10000 / 10000;
                const priceValue = this.convertAmountFilter(price, this.priceInfo.currency);
                return !this.accountHelper.isCommercialCustomer(this.account)
                    ? priceValue
                    : priceValue + ' ' + this.$translate.instant('TR_130219-775cda_TR');
            }
        }
    }
}

export class MoleculeFormProductPriceTemplateComponent implements ng.IComponentOptions {
    public bindings = {
        priceInfo: '<',
        pricePrefixText: '@?',
    };
    public template = require('./product-price-template.html');
    public controller =  MoleculeFormProductPriceTemplateController;
}
